import { render, staticRenderFns } from "./ForumBookmark.vue?vue&type=template&id=33b18eea&scoped=true&"
import script from "./ForumBookmark.vue?vue&type=script&lang=js&"
export * from "./ForumBookmark.vue?vue&type=script&lang=js&"
import style0 from "./ForumBookmark.vue?vue&type=style&index=0&id=33b18eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b18eea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabItem,VTabs,VTabsItems})
